// src/services/notificationService.ts
import apiClient from "../api/apiClient";

const TENANT_ID = process.env.REACT_APP_TENANT_ID ?? "1";

export interface SingleNotificationPayload {
    email: string;
    title: string;
    body: string;
}

export interface UserListNotificationPayload {
    emails: string[];
    title: string;
    body: string;
}

export interface BulkNotificationData {
    title: string;
    body: string;
    targetType: "ALL" | "CLASS" | "SUBSCRIPTION";
    classId?: number | null;
    mediumId?: number | null;
    subjectId?: number | null;
}

/**
 * Send a direct notification to a single user.
 */
export async function sendSingleNotification(payload: SingleNotificationPayload) {
    // POST /api/admin/notifications/user
    const resp = await apiClient.post("/admin/notifications/user", payload, {
        params: { tenantId: TENANT_ID }
    });
    return resp.data;
}

/**
 * Send a notification to a specific list of users (Emails).
 */
export async function sendUserListNotification(payload: UserListNotificationPayload) {
    // POST /api/admin/notifications/users
    const resp = await apiClient.post("/admin/notifications/users", payload, {
        params: { tenantId: TENANT_ID }
    });
    return resp.data;
}

/**
 * Send a broadcast notification with optional image.
 */
export async function sendBulkNotification(data: BulkNotificationData, imageFile?: File | null) {
    // POST /api/admin/notifications/send
    const formData = new FormData();
    formData.append("data", JSON.stringify(data));

    if (imageFile) {
        formData.append("image", imageFile);
    }

    const resp = await apiClient.post("/admin/notifications/send", formData, {
        params: { tenantId: TENANT_ID },
        headers: { "Content-Type": "multipart/form-data" }
    });
    return resp.data;
}